import React from 'react';
import { useDropzone } from 'react-dropzone';
import { filesPropertiesMapping } from '../../Components/helper';
import Loader from '../../Components/Utility/Loader/Loader';
import { toasterMsg } from '../../Components/Toaster/Toaster';

function DamDragDropFoldersFiles({ handleFolderFilesChange, handleDragOver }) {
  const [loadDragDrop, setLoadDragDrop] = React.useState(false);

  const onDrop = async (acceptedFiles) => {
    setLoadDragDrop(true);
    const maxFileSize = 50 * 1024 * 1024; // 50 MB
    const acceptedTypes = ['image/jpeg', 'image/png', 'image/webp', 'video/mp4', 'video/webm', 'video/quicktime'];
    const invalidFiles = [];
    acceptedFiles.forEach((file) => {
      if (file.size > maxFileSize || !acceptedTypes.includes(file.type)) {
        invalidFiles.push(file);
      }
    });
    if (invalidFiles.length > 0 || acceptedFiles?.length === 0) {
      toasterMsg(
        'Some files were not accepted. Please ensure all files are under 50 MB and of the correct type.(image/jpeg, image/png, image/webp, video/mp4, video/webm, video/quicktime)',
        'danger',
        5000,
      );
      handleDragOver(false);
    } else {
      const files = await filesPropertiesMapping(acceptedFiles);
      handleFolderFilesChange(files);
    }
    setLoadDragDrop(false);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    useFsAccessApi: false, // for better browser compatibility
    multiple: true, // allow multiple files
    accept: 'image/jpeg, image/png, image/webp, video/mp4, video/webm, video/quicktime',
    webkitdirectory: 'true', // to support folder drag and drop
    noClick: true,
  });

  return (
    <div {...getRootProps()} className="min-h-200" style={styles.dropzone}>
      {loadDragDrop ? (
        <Loader />
      ) : (
        <>
          <input {...getInputProps({ webkitdirectory: 'true' })} onClick={(event) => event.preventDefault()} />
          {isDragActive ? (
            <p>Drop here...</p>
          ) : (
            <div>
              <p className="f-20 font-weight-bold">Drag and Drop, file or folder here</p>
              <span className="fs-upload-dam icon-upload_icon_new" />
            </div>
          )}
        </>
      )}
    </div>
  );
}

const styles = {
  dropzone: {
    border: '2px dashed #cccccc',
    borderRadius: '0px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    color: '#666666',
    backgroundColor: '#FFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    zIndex: '9',
    width: 'calc(100% - 30px)',
    height: '301px',
  },
};

export default DamDragDropFoldersFiles;
